/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import _ from 'lodash';
const superagent = require('superagent');

/**
 * Perform request using super agent
 *
 * Assembles super agent request based on request object in state
 *
 * @param  {Object} request  Request state object
 * @return {Promise<Object>} Body response
 */
export function superAgentRequestHandler(request) {
  const { url, body, headers, query } = request;
  const method = request.method || 'GET';

  const superagentRequest = superagent(method, '/api' + url)
    .type('application/json')
    .set('X-UI-Token', 'status-ui-frontend'); // Identifies requests from our UI

  if (headers) {
    _.forEach(headers, (value, key) => {
      superagentRequest.set(key, value);
    });
  }

  if (query) {
    _.forEach(query, (value, key) => {
      superagentRequest.query({ [key]: value });
    });
  }

  if (body) {
    superagentRequest.send(body);
  }
  return superagentRequest;
}
